module.exports = __webpack_public_path__ + "media/images/arrow_drop_down-3dd6e49befa51f4b8e6264d1b7379a65.svg";